import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="Group Kitty"
      productUrl="/products/group-kitty"
      title="Refund Policy"
      lastUpdated="August 5, 2026"
    >
      <Section>
        <Paragraph>
          This Refund Policy applies to in-app purchases made through the <strong>Group Kitty</strong> app on Google Play and the Apple App Store, operated by{" "}
          <strong>Spurnest Techlabs</strong>. Group Kitty itself is free to download and use; optional purchases remove advertisements.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Remove Ads Purchase</SectionTitle>
        <Paragraph>
          The optional Remove Ads product (<code>com.spurnest.groupkitty.no_ads</code>) is a one-time in-app purchase processed entirely by Google Play or the Apple App Store. Spurnest Techlabs does not directly collect or hold your payment details.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Google Play Refunds</SectionTitle>
        <Paragraph>To request a refund for a Google Play purchase:</Paragraph>
        <List>
          <li>Open Google Play Store → Profile → Payments &amp; subscriptions → Budget &amp; history</li>
          <li>Select the Group Kitty purchase and request a refund, or contact Google Play support</li>
          <li>Refunds are subject to Google Play's refund policy and eligibility criteria</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Apple App Store Refunds</SectionTitle>
        <Paragraph>To request a refund for an App Store purchase:</Paragraph>
        <List>
          <li>Visit Apple's Report a Problem page (reportaproblem.apple.com) and sign in with your Apple ID</li>
          <li>Select the Group Kitty purchase and submit a refund request</li>
          <li>Refunds are subject to Apple's refund policy and eligibility criteria</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Restoring Purchases</SectionTitle>
        <Paragraph>
          If you reinstall the app or switch devices, use the store's restore-purchases flow (or sign in with the same Google / Apple account used for the purchase) so Remove Ads status can be restored. Contact us if restore fails after a successful purchase.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          For billing questions, contact us at{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>{" "}
          and we will help you with the Google Play or App Store refund process where possible.
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
